(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-central-gallery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.ace-central-track');
      const cards = Array.from(track.querySelectorAll('.ace-central-card'));
      const toggle = root.querySelector('[data-central-toggle]');
      const counter = root.querySelector('output');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, paused = motion.matches, pointerStart = null, swiped = false;
      const label = () => { toggle.textContent = paused ? root.dataset.play : root.dataset.pause; };
      const stop = () => { paused = true; label(); };
      const render = () => {
        cards.forEach((card, i) => {
          card.style.transform = 'translateX(' + ((i - index) * 100) + '%)';
          card.inert = i !== index;
          card.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        counter.textContent = (index + 1) + ' / ' + cards.length;
      };
      const move = delta => { index = (index + delta + cards.length) % cards.length; render(); };
      root.querySelector('[data-central-prev]').addEventListener('click', () => {stop(); move(-1);});
      root.querySelector('[data-central-next]').addEventListener('click', () => {stop(); move(1);});
      toggle.addEventListener('click', () => {paused = !paused; label();});
      track.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        stop(); swiped = false; pointerStart = {x:event.clientX, y:event.clientY};
      });
      track.addEventListener('pointerup', event => {
        if (!pointerStart) return;
        const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {swiped = true; move(dx < 0 ? 1 : -1);}
      });
      track.addEventListener('pointercancel', () => {pointerStart = null;});
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('click', event => {if(swiped){event.preventDefault(); event.stopPropagation(); swiped = false;}}, true);
      track.addEventListener('keydown', event => {if(event.key === 'ArrowRight' || event.key === 'ArrowLeft'){event.preventDefault(); stop(); move(event.key === 'ArrowRight' ? 1 : -1);}});
      const timer = window.setInterval(() => {
        if (!root.isConnected) {window.clearInterval(timer); return;}
        const bounds = root.getBoundingClientRect();
        if (!paused && !root.matches(':hover') && !root.contains(document.activeElement) && bounds.bottom > 0 && bounds.top < window.innerHeight && !document.hidden) move(1);
      }, 5000);
      motion.addEventListener('change', event => {if(event.matches) stop();});
      render(); label();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-v11-preview"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ace-v11]').forEach(root => {
root.querySelectorAll('.avp-thumb').forEach(button => button.addEventListener('click', () => {
const image = root.querySelector('.avp-main-image');
image.src = button.dataset.image;
image.removeAttribute('srcset');
image.alt = button.dataset.alt;
root.querySelectorAll('.avp-thumb').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
}));
const variant = root.querySelector('#ace-v11-variant');
if (variant) variant.addEventListener('change', () => { const url = new URL(location.href); url.searchParams.set('variant',variant.value); location.assign(url.toString()); });
});

  } catch(e) { console.error(e); }
})();
})();
